import { Route, Routes } from "react-router-dom";

import "custom.css";
import AlertContextProvider from "components/AlertContextProvider";
import ThemeContextProvider from "components/ThemeContextProvider";
import Layout from "components/Layout";
import UserContextProvider from "components/UserContextProvider";
import { routes } from "AppRoutes";

export default function App() {
    return (
        <UserContextProvider>
            <ThemeContextProvider>
                <AlertContextProvider>
                    <Layout>
                        <Routes>
                        {/* test comment push to demo */}
                        {routes.map((route, i) => (
                            <Route
                                key={route.path ?? i}
                                path={route.path}
                                element={route.element}
                            >
                                {route.children?.map((child) => (
                                    <Route
                                        key={child.path}
                                        path={child.path}
                                        element={child.element}
                                    />
                                ))}
                            </Route>
                        ))}
                        </Routes>
                    </Layout>
                </AlertContextProvider>
            </ThemeContextProvider>
        </UserContextProvider>
    );
}
